import { createSlice } from "@reduxjs/toolkit";

type initialStateType = {
  count: number;
};
const initialState: initialStateType = {
  count: 0,
};

export const stateSlice = createSlice({
  // 命名空间，在调用action的时候会默认的设置为action的前缀collapsedSlice/changeCollapsed
  name: "stateSlice",
  // 初始值
  initialState: initialState,
  // 这里的属性会自动的导出为collapsedSlice.actions，在组件中可以直接通过dispatch进行触发
  reducers: {
    changeCount: (state) => {
      state.count += 1;
    },
  },
});

// 导出actions
export const { changeCount } = stateSlice.actions;

// 导出reducer，在创建store时使用到
export default stateSlice.reducer;
